import type { LocationQueryValue } from 'vue-router'
import type { SortingState } from '@tanstack/vue-table'
import { normalizeToArray } from './array.js'

/**
 * Generates query params from Tanstack Table sorting state.
 * The query param follow the JSON:API standard for sorting.
 * @see https://jsonapi.org/format/#fetching-sorting
 */
export function sortingStateToQueryParam(sortingState: SortingState) {
  return sortingState.map((columnSort) => {
    const prefix = columnSort.desc ? '-' : ''
    return prefix + columnSort.id
  })
}

const isTruthy = <T>(value: T | null | ''): value is T => !!value

/**
 * Generates TanStack Table sorting state from query params.
 * The query param is expected to follow the JSON:API standard for sorting.
 * @see https://jsonapi.org/format/#fetching-sorting
 */
export function queryParamToSortingState(
  queryValue: LocationQueryValue | LocationQueryValue[],
): SortingState {
  if (!queryValue) {
    return []
  }

  return normalizeToArray(queryValue)
    .filter(isTruthy)
    .map((sortString) => {
      const desc = sortString.startsWith('-')
      const id = desc ? sortString.slice(1) : sortString

      return { id, desc }
    })
}
